import { useEffect, useState } from "react";
import { adminApi } from "../api";
import { Trash2, Check, Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [opened, setOpened] = useState(null);

  const load = () =>
    adminApi.get("/admin/contact-messages").then((r) => setItems(r.data));

  useEffect(() => {
    load();
  }, []);

  const openMsg = async (m) => {
    setOpened(m);
    if (!m.read) {
      try {
        await adminApi.post(`/admin/contact-messages/${m.id}/read`);
        load();
      } catch {}
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare il messaggio?")) return;
    await adminApi.delete(`/admin/contact-messages/${id}`);
    toast.success("Eliminato");
    if (opened?.id === id) setOpened(null);
    load();
  };

  return (
    <div data-testid="admin-messages-page">
      <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#C48F56]">
        CMS
      </div>
      <h1 className="mt-2 font-display font-light text-5xl tracking-tightest">
        Messaggi
      </h1>
      <p className="mt-3 text-white/60 max-w-xl">
        Richieste ricevute dal form di contatto.
      </p>

      <div className="mt-10 grid lg:grid-cols-12 gap-5">
        <div className="lg:col-span-5 rounded-2xl border border-white/10 bg-[#0F0F14] divide-y divide-white/5">
          {items.length === 0 && (
            <div className="p-8 text-center text-white/40 text-sm">
              Nessun messaggio ricevuto.
            </div>
          )}
          {items.map((m) => (
            <button
              key={m.id}
              onClick={() => openMsg(m)}
              data-testid={`msg-${m.id}`}
              className={`w-full text-left p-4 flex items-start gap-3 hover:bg-white/[0.02] transition-colors ${
                opened?.id === m.id ? "bg-white/[0.03]" : ""
              }`}
            >
              <div className="mt-1">
                {m.read ? (
                  <Check size={14} className="text-white/30" />
                ) : (
                  <span className="block h-2 w-2 rounded-full bg-[#C48F56]" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-medium truncate">{m.name}</span>
                  <span className="font-mono text-[10px] text-white/40 shrink-0">
                    {new Date(m.created_at).toLocaleDateString("it-IT")}
                  </span>
                </div>
                <div className="text-xs text-white/50 truncate">{m.email}</div>
                <div className="mt-1 text-sm text-white/70 truncate">
                  {m.subject}
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="lg:col-span-7 rounded-2xl border border-white/10 bg-[#0F0F14] p-8 min-h-[400px]">
          {opened ? (
            <div>
              <div className="flex items-start justify-between gap-6">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#C48F56]">
                    {opened.subject}
                  </div>
                  <h2 className="mt-2 font-display text-3xl tracking-tight">
                    {opened.name}
                  </h2>
                  <div className="mt-2 text-sm text-white/60">
                    <a
                      href={`mailto:${opened.email}`}
                      className="hover:text-white"
                    >
                      {opened.email}
                    </a>
                    {opened.phone && <span> · {opened.phone}</span>}
                  </div>
                  <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                    {new Date(opened.created_at).toLocaleString("it-IT")}
                  </div>
                </div>
                <button
                  onClick={() => remove(opened.id)}
                  className="h-9 w-9 rounded-full border border-white/10 grid place-items-center hover:bg-red-500/10 hover:text-red-400 hover:border-red-500/30"
                >
                  <Trash2 size={14} />
                </button>
              </div>
              <hr className="my-6 border-white/5" />
              <p className="text-white/80 leading-relaxed whitespace-pre-wrap">
                {opened.message}
              </p>
              <div className="mt-8">
                <a
                  href={`mailto:${opened.email}?subject=Re: ${encodeURIComponent(
                    opened.subject
                  )}`}
                  className="inline-flex items-center gap-2 rounded-full bg-white text-black px-5 py-2 text-sm hover:bg-[#C48F56]"
                >
                  <Mail size={14} /> Rispondi via email
                </a>
              </div>
            </div>
          ) : (
            <div className="h-full grid place-items-center text-white/40 text-sm">
              Seleziona un messaggio
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
